<p *ngIf="loading" class="ai-settings__message" role="status" ttTranslateWord="ai_settings_loading_providers"></p>
<tt-toast *ngIf="errorMessage" role="alert" ttType="danger" [ttTitle]="errorMessage" [ttTranslateTitle]="translateErrorMessage"></tt-toast>

<ng-container *ngIf="!!page">
    <tt-tabs [(ttSelectedId)]="page.main_tab" (ttSelectedIdChange)="onTabChanged()">
        <tt-tab ttId="SETUP" ttLabel="ai_settings_provider_setup" ttIcon="far fa-key"></tt-tab>
        <tt-tab ttId="MODELS" ttLabel="ai_settings_provider_models" ttIcon="far fa-stream" [ttDisabled]="!hasProviders"></tt-tab>
    </tt-tabs>

    <tt-ai-settings-providers-setup
        *ngIf="openedTabs.has('SETUP')"
        [hidden]="page.main_tab !== 'SETUP'"
        [active]="page.main_tab === 'SETUP'"
        [page]="page"
        (hasProvidersChange)="hasProviders = $event"
    ></tt-ai-settings-providers-setup>
    <tt-ai-settings-models *ngIf="openedTabs.has('MODELS')" [hidden]="page.main_tab !== 'MODELS'" [active]="page.main_tab === 'MODELS'" [page]="page"></tt-ai-settings-models>
</ng-container>
